
import React, { useState } from 'react';
import { Camera } from 'lucide-react';

export const Gallery: React.FC = () => {
  const [filter, setFilter] = useState('All');
  
  const categories = ['All', 'Suites', 'Dining', 'Architecture', 'Grounds', 'Moments'];
  
  const images = [
    { url: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/617366007.jpg?k=2227cf19a9bff631fba5d848886264584e43c3bdae48576ae3389d4f8ec5d5bf&o=', category: 'Architecture', height: 'h-80' },
    { url: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/617365988.jpg?k=eaaec37907c42972ec8d66159f7501412d5c4aaab523034544806bcdd2e3670f&o=', category: 'Grounds', height: 'h-64' },
    { url: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/617366092.jpg?k=e0927368c9de1a593fd87a4ae959256e7d467375c6db0784f84ecdf9310c9663&o=', category: 'Suites', height: 'h-96' },
    { url: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/617366108.jpg?k=7b80b7cdd46a08e77fc09b44576ec650a518ab4d51fea880942408aa5caa2590&o=', category: 'Suites', height: 'h-72' },
    { url: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/617366099.jpg?k=e18333fc75f4d560c3c21b851811a630ff5114812bdc85dc0e38b273efa661e6&o=', category: 'Suites', height: 'h-96' },
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSxoQ6jxhxpdwKoC2BPV3vuJ3XUBKB_6_WFHKtIR6jfa9ONiAZ1YWDD09v4dr3MkfDfHRQr8NjmYkpfvjYbTiotXJykYDX2PMUlElnAYnr6fnB2UNFj6ada2-Kb-KXqz83jl_XSzfwCFo-km=w253-h353-k-no', category: 'Moments', height: 'h-64' },
    { url: 'https://www.hotelscombined.com/himg/a2/eb/42/expedia_group-853408-60650480-661766.jpg', category: 'Architecture', height: 'h-80' },
    { url: 'https://content.r9cdn.net/rimg/himg/2f/7c/cf/expedia_group-853408-216340697-623837.jpg?width=500&height=350&xhint=540&yhint=333&crop=true', category: 'Architecture', height: 'h-96' },
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSxHcjSIeZWqL85SqS6vmSniAMS1S4iz-mERV5vy2MHBrvrFx4CYAPzEiCzlt9oGB5vMJ_GiVBQ9-z3WCsNOJghKNj5CFtJc5O-TxOarpcEUvJVonFsxBjuoznTTmTeL9zv8euQY=w253-h337-k-no', category: 'Grounds', height: 'h-72' },
    { url: 'https://res.cloudinary.com/dxplhh55e/image/upload/v1769044974/mandodari_2_page-0002_edqeuo.jpg', category: 'Dining', height: 'h-80' },
    { url: 'https://lh3.googleusercontent.com/p/AF1QipOw0M8vR8VI127syCGqH9MAeG05sFtgjUKA1hko=w253-h168-k-no', category: 'Dining', height: 'h-64' },
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzpYhazyuxO3eFjuZFspScqqLy7QYitQmqgqcvEzKvhnhGTJRBxpZoFFAOjozCTNVyScF1U-Q353tTBOBENJ4CtBCDKVZYiy5szawTzsGiUwecjr5cGN3NM21StWitXrDM4cGi_=s1360-w1360-h1020-rw', category: 'Architecture', height: 'h-96' },
    { url: 'https://res.cloudinary.com/dxplhh55e/image/upload/v1769046339/mandodari_2_page-0002_r8ksl0.jpg', category: 'Suites', height: 'h-72' },
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSx9reXKSY87De78jRI8SWUuwaCj2GT3NQj3Br_L_8ndkZaYAWzpKg-94VTitywk5reI4s0-RtRK2ukKU7CLVdc3ZlrXMexi4l-PUKC1txQBFtYp7uFTNiNOEKTHF9K8SxCTIxYa=s1360-w1360-h1020-rw', category: 'Moments', height: 'h-96' },
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSxOOYXiJNQ5zoFs0ve_GhR2bBeNyuc_FmE4kLGPNg8Uw3GTXCS6_1oX2NCcjjkWrg1CKssEjuem9zd_3WL0v5zpw0f7LuUiQpVEP0VYwvEr0cFqyhGlgmJi6DpLHlrZctGE_v4=s1360-w1360-h1020-rw', category: 'Architecture', height: 'h-64' },
    { url: 'https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzK2qJOEkDX9h0y2MbqxvMHQ1z8SkU4fZb1YVCzGDuyDGkZv9eRnOe18tNzg87v4pBnBYyDUWDkjCI_D5oQiTUveDKPy-BUrVMfya-RNMnuKg-9cdZCeH074RXa6VZOKfQ1qHc=s1360-w1360-h1020-rw', category: 'Moments', height: 'h-80' }
  ];

  const filteredImages = filter === 'All' ? images : images.filter(img => img.category === filter);

  return (
    <div className="pt-40 pb-40 bg-[#0D0D0D]">
      <div className="max-w-[1800px] mx-auto px-6">
        <div className="text-center mb-24 reveal">
          <h4 className="text-[#C5A059] uppercase tracking-[0.6em] font-black text-[9px] mb-6">Visual Anthology</h4>
          <h1 className="text-5xl md:text-8xl lg:text-[10rem] font-bold serif text-white italic tracking-tighter leading-[0.85]">A Glimpse of <br /> <span className="text-[#C5A059]">Perfection.</span></h1>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-12 mb-20 reveal stagger-1 px-4">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`text-[9px] md:text-[11px] font-black uppercase tracking-[0.4em] transition-all duration-700 pb-3 border-b-2 ${
                filter === cat ? 'text-[#C5A059] border-[#C5A059]' : 'text-stone-600 border-transparent hover:text-white'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="columns-2 md:columns-2 lg:columns-3 xl:columns-4 gap-4 md:gap-6 space-y-4 md:space-y-6">
          {filteredImages.map((img, idx) => (
            <div 
              key={idx} 
              className="break-inside-avoid reveal group relative overflow-hidden rounded-[1.5rem] md:rounded-[2rem] luxury-shadow cursor-pointer transition-all duration-700 hover:z-20 bg-stone-900 photo-glow"
            >
              <div className="blur-[40px] -mr-10 -mt-10 transition-opacity group-hover:opacity-100 bg-orange-500/10 opacity-50 w-32 h-32 rounded-full absolute top-0 right-0 z-10 pointer-events-none"></div>
              
              <div className={`${img.height} relative overflow-hidden`}>
                <img 
                  src={img.url} 
                  alt={img.category}
                  className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-110"
                  loading="lazy"
                />
                
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-700 flex flex-col justify-end p-4 md:p-8">
                  <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-700">
                    <span className="text-[#C5A059] text-[7px] md:text-[9px] font-black uppercase tracking-[0.5em] mb-1 md:mb-2 block">{img.category}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-40 text-center reveal">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-[#141414] rounded-2xl flex items-center justify-center mx-auto mb-10 text-[#C5A059] border border-white/5 shadow-xl">
            <Camera size={28} strokeWidth={1.5} />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold serif text-white mb-6 italic">Capturing the Eternal.</h2>
          <p className="text-stone-500 max-w-xl mx-auto font-light leading-relaxed text-base md:text-lg px-6">
            Our estate is a living gallery of moments. Every frame presented here is an unedited window into the Bevary Guest experience.
          </p>
          <div className="mt-12">
            <button className="text-[#C5A059] border-b border-[#C5A059]/30 pb-2 font-black uppercase tracking-[0.3em] text-[9px] hover:text-white hover:border-white transition-all">
              Request Full Press Kit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
